// Handler Popup Pencarian Premium Hero Grid
document.addEventListener('DOMContentLoaded', function () {
  const searchForms = document.querySelectorAll('.premium-hero-grid__search-form');
  const searchPopups = document.querySelectorAll('.premium-hero-grid__search-popup');
  const searchInputs = document.querySelectorAll('.premium-hero-grid__search-input');
  const searchPopupInputs = document.querySelectorAll('.premium-hero-grid__search-input-popup');
  const searchPopupTransparents = document.querySelectorAll('.premium-hero-grid__search-popup-transparent');
  const moveRightElements = document.querySelectorAll('.premium-hero-grid__text-content-inner.move-right');
  const searchPopupForms = document.querySelectorAll('.premium-hero-grid__search-form-popup');

  function isPopupNoResultsState(popup) {
    if (!popup) return false;
    const container = popup.querySelector('#premium-hero-grid__search-results');
    if (!container) return false;

    // AJAX snippet no result: <div class="search-results-wrapper 0"><p>no results found.</p></div>
    const wrapper = container.querySelector('.search-results-wrapper');
    if (wrapper) {
      const wrapperClass = ` ${wrapper.className.toLowerCase()} `;
      if (wrapperClass.indexOf(' 0 ') !== -1) return true;
    }

    const text = (container.textContent || '').toLowerCase().replace(/\s+/g, ' ').trim();
    return text.indexOf('no results found') !== -1 || text.indexOf('produk tidak ditemukan') !== -1;
  }

  function isPopupMinCharsHintState(popup) {
    if (!popup) return false;
    const container = popup.querySelector('#premium-hero-grid__search-results');
    if (!container) return false;
    const text = (container.textContent || '').toLowerCase().replace(/\s+/g, ' ').trim();
    return text.indexOf('type at least 3 letters') !== -1;
  }

  /** false sampai input pertama / AJAX selesai — cegah Enter di jeda debounce atau sebelum DOM update. */
  function isPopupSearchUiReady(popup) {
    if (!popup) return true;
    return popup.dataset.searchUiReady !== 'false';
  }

  function isPopupSearchSubmitBlocked(popup) {
    if (!popup) return true;
    if (!isPopupSearchUiReady(popup)) return true;
    return (
      isPopupNoResultsState(popup) ||
      isPopupMinCharsHintState(popup) ||
      isPopupQueryBelowMinLength(popup)
    );
  }

  function syncPopupSearchButtonState(popup) {
    if (!popup) return;
    const searchButton = popup.querySelector('.premium-hero-grid__search-button-popup');
    if (!searchButton) return;
    const disabled = isPopupSearchSubmitBlocked(popup);
    searchButton.disabled = disabled;
    searchButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    searchButton.classList.toggle('is-disabled', disabled);
  }

  function setPopupSearchUiReady(popup, ready) {
    if (!popup) return;
    if (ready) {
      delete popup.dataset.searchUiReady;
    } else {
      popup.dataset.searchUiReady = 'false';
    }
    syncPopupSearchButtonState(popup);
  }

  function initNoResultsInteractionGuard() {
    // Block Enter submit in popup input when no-results state is active.
    searchPopupInputs.forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        const popup = input.closest('.premium-hero-grid__search-popup');
        syncPopupSearchButtonState(popup);
        if (!isPopupSearchSubmitBlocked(popup)) return;
        e.preventDefault();
        e.stopPropagation();
      }, true);
      input.addEventListener('input', function () {
        const popup = input.closest('.premium-hero-grid__search-popup');
        syncPopupSearchButtonState(popup);
      });
    });

    // Block click on links/spans/buttons in results area when no-results is shown.
    searchPopups.forEach(function (popup) {
      syncPopupSearchButtonState(popup);
      const resultsContainer = popup.querySelector('#premium-hero-grid__search-results');
      if (resultsContainer && window.MutationObserver) {
        const observer = new MutationObserver(function () {
          syncPopupSearchButtonState(popup);
        });
        observer.observe(resultsContainer, { childList: true, subtree: true, characterData: true });
      }
      popup.addEventListener('click', function (e) {
        syncPopupSearchButtonState(popup);
        const searchButton = e.target.closest('.premium-hero-grid__search-button-popup');
        if (searchButton && searchButton.disabled) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        if (!isPopupSearchSubmitBlocked(popup)) return;
        const interactive = e.target.closest('a, button, [role="button"], span');
        if (!interactive) return;
        if (!interactive.closest('#premium-hero-grid__search-results')) return;
        e.preventDefault();
        e.stopPropagation();
      }, true);
    });
  }

  initNoResultsInteractionGuard();

  function updatePopupCaret(input) {
    if (!input) return;
    const form = input.closest('.premium-hero-grid__search-form-popup');
    if (!form) return;
    const caret = form.querySelector('.premium-hero-grid__search-caret');
    if (!caret) return;
    const hasValue = input.value && input.value.trim() !== '';
    if (hasValue) {
      caret.style.opacity = '0';
      caret.style.animation = 'none';
    } else {
      caret.style.opacity = '1';
      caret.style.animation = '';
    }
  }

  searchPopupInputs.forEach(function (input) {
    updatePopupCaret(input);
    input.addEventListener('input', function () {
      updatePopupCaret(input);
    });
    input.addEventListener('blur', function () {
      updatePopupCaret(input);
    });
  });

  if ($("[recommendation-settings]").length) {
    var settingsArray = [];
    $("[recommendation-settings]").each(function () {
      var settings = JSON.parse($(this).attr("recommendation-settings"));
      settingsArray.push(settings);
    });
    console.log('settingsArray', settingsArray);
    function sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function callApi(product, retryCount = 0) {
      const maxRetries = 15; // Batas maksimal percobaan
      const retryDelay = 1500; // Delay 1 detik (1000 ms)

      const product_name = product.product_name;
      const sameGender = product.sameGender;
      const colorProduct = product.colorProduct;
      const productCurrentUrl = location.href.split("products")[0] ?? "";
      const productHandle = product.productHandle;

      const data_current = {
        product_title: product_name,
        gender: sameGender,
        different_gender: "",
        handle: productHandle,
        color: colorProduct,
        shop: Shopify.shop
      };

      const $colorSwatchList = $(`.color-swatch-pi--list[data-product="${productHandle}"]`);
      try {
        const response = await $.ajax({
          type: "POST",
          url: "https://on-running.devbdd.com/config/getProductSame_v2",
          data: data_current,
          crossDomain: true
        });

        const data = typeof response === "string" ? JSON.parse(response) : response;

        const displayTags = (product.displayTags || "").split("|").filter(Boolean);
        const tagLabels = displayTags.map(t => t.replace(/-/g, " ").toUpperCase());
        const tagHtml = tagLabels.length > 0
          ? `<div class="caption-available-colors caption-display-tags">${tagLabels.join(" • ")}</div>`
          : "";

        if (data != null && data.data_same && data.data_same.length > 0) {
          $colorSwatchList.html("").removeClass("loading");

          const data_same = data.data_same;
          const colorCount = data_same.length;

          let content;
          if (tagHtml) {
            content = tagHtml;
          } else {
            content = `
                    <div class="caption-available-colors">
                      AVAILABLE IN ${colorCount} COLORS
                    </div>
                  `;
          }

          $colorSwatchList.html(content);
        }
        else if (retryCount < maxRetries) {
          // console.log(`Retrying API call for ${product_name}, attempt ${retryCount + 1}`);
          await sleep(retryDelay); // Tunggu 1 detik sebelum retry
          return callApi(product, retryCount + 1);

        } else {
          // console.log(`Failed to load data for ${product_name} after ${maxRetries} attempts.`);
          $colorSwatchList.html(tagHtml || "<p></p>").removeClass("loading");
        }
      } catch (err) {
        console.log(`Error occurred during API call for ${product_name}`, err);
        const displayTags = (product.displayTags || "").split("|").filter(Boolean);
        const tagLabels = displayTags.map(t => t.replace(/-/g, " ").toUpperCase());
        const fallbackTagHtml = tagLabels.length > 0
          ? `<div class="caption-available-colors caption-display-tags">${tagLabels.join(" • ")}</div>`
          : "";
        $colorSwatchList.html(fallbackTagHtml).removeClass("loading");
        console.log(product_name + " not found item")
      }
    }

    async function processQueueParallel(settingsArray) {
      const promises = settingsArray.map(product => callApi(product)); // Process all calls in parallel
      await Promise.all(promises);
      console.warn("color swatch completed.");
    }

    /** Setelah filter collection (AJAX), grid diganti — panggil ulang API untuk kartu baru yang masih loading. */
    function collectRecommendationSettingsFromDom() {
      var arr = [];
      $("[recommendation-settings]").each(function () {
        try {
          arr.push(JSON.parse($(this).attr("recommendation-settings")));
        } catch (e) {
          console.warn("recommendation-settings parse error", e);
        }
      });
      return arr;
    }

    function refreshColorSwatchAfterFacetUpdate() {
      if ($(".template-product").length) return;
      var next = collectRecommendationSettingsFromDom();
      if (!next.length) return;
      processQueueParallel(next);
    }

    document.addEventListener("facetFiltersForm:updated", function () {
      setTimeout(refreshColorSwatchAfterFacetUpdate, 0);
    });

    // Mulai memproses queue secara paralel
    if (!$(".template-product").length) {
      processQueueParallel(settingsArray);
    }
    else {
      // let process = setInterval(() => {
      //     let product_detail_swatch = localStorage.getItem("product_detail_swatch")
      //     if (product_detail_swatch) {
      //         localStorage.removeItem("product_detail_swatch")

      //         processQueueParallel(settingsArray);
      //         clearInterval(process);
      //     }
      // }, 1000);
    }
  }

  // Toggle Collapsible (Key features dropdown)
  (function initCollapsibleToggle() {
    document.querySelectorAll('[data-action="toggle-collapsible"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        var targetId = this.getAttribute('aria-controls');
        var inner = targetId ? document.getElementById(targetId) : this.nextElementSibling;

        if (!inner || !inner.classList.contains('Collapsible__Inner')) return;

        if (expanded) {
          inner.classList.add('Collapsible__Inner--closed');
          inner.classList.remove('Collapsible__Inner--open');
          this.setAttribute('aria-expanded', 'false');
          this.classList.remove('is-open');
        } else {
          inner.classList.remove('Collapsible__Inner--closed');
          inner.classList.add('Collapsible__Inner--open');
          this.setAttribute('aria-expanded', 'true');
          this.classList.add('is-open');
        }
      });
    });
  })();

  // Helper: cari popup yang terkait dengan form/input
  // - Di premium-hero-grid section: popup adalah SIBLING dari .premium-hero-grid (bukan child)
  // - Di header: popup ada di dalam .header
  function getPopupForInput(input) {
    if (!input) return searchPopups[0];
    // Input di premium-hero-grid: popup adalah sibling, cari di parent
    const gridEl = input.closest('.premium-hero-grid');
    if (gridEl && gridEl.parentElement) {
      const popup = gridEl.parentElement.querySelector('.premium-hero-grid__search-popup');
      if (popup) return popup;
    }
    // Input di header: popup ada di dalam header
    const headerEl = input.closest('.header');
    if (headerEl) {
      const popup = headerEl.querySelector('.premium-hero-grid__search-popup');
      if (popup) return popup;
    }
    return searchPopups[0];
  }

  // Input utama (.premium-hero-grid__search-input) yang berpasangan dengan popup ini
  function getMainSearchInputForPopup(popup) {
    if (!popup) return null;
    const headerEl = popup.closest('.header');
    if (headerEl) {
      const inp = headerEl.querySelector('.premium-hero-grid__search-input');
      if (inp) return inp;
    }
    const parent = popup.parentElement;
    if (parent) {
      const inp = parent.querySelector('.premium-hero-grid__search-input');
      if (inp) return inp;
    }
    return null;
  }

  function getPopupInputForMainInput(input) {
    const popup = getPopupForInput(input);
    if (!popup) return null;
    return popup.querySelector('.premium-hero-grid__search-input-popup') || popup.querySelector('input[name="q"]');
  }

  let syncingSearchInputPair = false;

  function syncSearchInputPair(sourceInput, targetInput, dispatchInputEvent) {
    if (!sourceInput || !targetInput || syncingSearchInputPair) return;
    const nextValue = sourceInput.value || '';
    if ((targetInput.value || '') === nextValue) return;

    syncingSearchInputPair = true;
    targetInput.value = nextValue;
    if (dispatchInputEvent) {
      targetInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
    syncingSearchInputPair = false;
  }

  var MIN_SEARCH_POPUP_CHARS = 3;
  function searchInputHasMinChars(input) {
    if (!input) return false;
    return String(input.value || '').trim().length >= MIN_SEARCH_POPUP_CHARS;
  }

  function getPopupSearchInput(popup) {
    if (!popup) return null;
    return popup.querySelector('.premium-hero-grid__search-input-popup') || popup.querySelector('input[name="q"]');
  }

  /** Blok submit/Enter dari nilai input langsung (1–2 karakter) — tidak nunggu DOM #premium-hero-grid__search-results keburu update. */
  function isPopupQueryBelowMinLength(popup) {
    const input = getPopupSearchInput(popup);
    if (!input) return false;
    const len = String(input.value || '').trim().length;
    return len > 0 && len < MIN_SEARCH_POPUP_CHARS;
  }

  // Sinkronisasi dua arah: input utama <-> input popup agar value tidak bentrok.
  searchInputs.forEach(function (mainInput) {
    if (!mainInput) return;
    mainInput.addEventListener('input', function () {
      const popupInput = getPopupInputForMainInput(mainInput);
      const popup = getPopupForInput(mainInput);
      const popupIsOpen = popup && popup.classList.contains('show');
      syncSearchInputPair(mainInput, popupInput, Boolean(popupIsOpen));
    }, true);
  });

  searchPopupInputs.forEach(function (popupInput) {
    if (!popupInput) return;
    popupInput.addEventListener('input', function () {
      const popup = popupInput.closest('.premium-hero-grid__search-popup');
      const mainInput = getMainSearchInputForPopup(popup);
      syncSearchInputPair(popupInput, mainInput, false);
    }, true);
  });

  function getPopupForOpenButton(openBtn) {
    if (!openBtn) return null;

    const headerEl = openBtn.closest('.header');
    if (headerEl) {
      const headerPopup = headerEl.querySelector('.premium-hero-grid__search-popup');
      if (headerPopup) return headerPopup;
    }

    const gridEl = openBtn.closest('.premium-hero-grid');
    if (gridEl) {
      let sibling = gridEl.nextElementSibling;
      while (sibling) {
        if (sibling.classList && sibling.classList.contains('premium-hero-grid__search-popup')) {
          return sibling;
        }
        sibling = sibling.nextElementSibling;
      }

      const sectionEl = openBtn.closest('.shopify-section') || gridEl.parentElement;
      if (sectionEl) {
        const sectionPopup = sectionEl.querySelector('.premium-hero-grid__search-popup');
        if (sectionPopup) return sectionPopup;
      }

      const nestedPopup = gridEl.querySelector('.premium-hero-grid__search-popup');
      if (nestedPopup) return nestedPopup;
    }

    for (let i = 0; i < searchPopups.length; i++) {
      if (!searchPopups[i].closest('.header')) return searchPopups[i];
    }
    return searchPopups[0] || document.querySelector('.premium-hero-grid__search-popup');
  }

  // Mobile: tombol icon-only buka search popup (header / premium-hero-grid)
  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-open-search-popup], .premium-hero-grid__mobile-search');
    if (!openBtn) return;

    const popup = getPopupForOpenButton(openBtn);
    const popupInput = popup ? getPopupSearchInput(popup) : null;
    if (!popup) return;

    e.preventDefault();
    e.stopPropagation();
    showSearchPopup(null, popup, null, popupInput, null);
  }, true);

  // Event delegation: handle klik pada search form/input (fallback untuk mobile - popup di sibling)
  document.addEventListener('click', function (e) {
    const form = e.target.closest('.premium-hero-grid__search-form');
    if (!form) return;
    const searchInput = form.querySelector('.premium-hero-grid__search-input');
    if (!searchInput) return;
    if (!searchInputHasMinChars(searchInput)) return;
    const popup = getPopupForInput(searchInput);
    const popupInput = popup ? popup.querySelector('.premium-hero-grid__search-input-popup') : null;
    if (popup) {
      e.preventDefault();
      e.stopPropagation();
      showSearchPopup(form, popup, searchInput, popupInput, null);
      return;
    }
  }, true);

  document.addEventListener('focusin', function (e) {
    if (e.target.classList && e.target.classList.contains('premium-hero-grid__search-input')) {
      const searchInput = e.target;
      if (!searchInputHasMinChars(searchInput)) return;
      const form = searchInput.closest('.premium-hero-grid__search-form');
      const popup = getPopupForInput(searchInput);
      const popupInput = popup ? popup.querySelector('.premium-hero-grid__search-input-popup') : null;
      if (popup && form) {
        showSearchPopup(form, popup, searchInput, popupInput, null);
      }
    }
  }, true);

  // Handle setiap form dan popup secara individual
  searchForms.forEach(function (searchForm, index) {
    const searchPopup = searchPopups[index] || searchPopups[0];
    const searchInput = searchInputs[index];
    const searchPopupInput = searchPopupInputs[index];
    const searchPopupTransparent = searchPopupTransparents[index];
    const searchPopupForm = searchPopupForms[index];
    const moveRightElement = moveRightElements[index];

    if (!searchForm || !searchPopup) return;

    // Buka popup hanya setelah minimal MIN_SEARCH_POPUP_CHARS karakter (trim) di input
    if (searchInput && searchPopup) {
      const relatedPopup = getPopupForInput(searchInput);
      const relatedPopupInput = relatedPopup ? relatedPopup.querySelector('.premium-hero-grid__search-input-popup') : searchPopupInput;

      function maybeShowSearchPopup() {
        if (!searchInputHasMinChars(searchInput)) return;
        if (relatedPopup && relatedPopup.classList.contains('show')) return;
        showSearchPopup(searchForm, relatedPopup, searchInput, relatedPopupInput, moveRightElement);
      }

      searchInput.addEventListener('focus', function () {
        if (searchInputHasMinChars(searchInput)) maybeShowSearchPopup();
      }, true);

      searchInput.addEventListener('click', function (e) {
        if (searchInputHasMinChars(searchInput)) {
          e.preventDefault();
          maybeShowSearchPopup();
        }
      }, true);

      searchInput.addEventListener('input', function () {
        maybeShowSearchPopup();
      }, true);
    }

    // Handle submit form - tampilkan popup sebagai gantinya redirect
    searchForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!searchInputHasMinChars(searchInput)) return;
      const relatedPopup = getPopupForInput(searchInput);
      showSearchPopup(searchForm, relatedPopup, searchInput, relatedPopup ? relatedPopup.querySelector('.premium-hero-grid__search-input-popup') : searchPopupInput, moveRightElement);
    });

    searchForm.addEventListener('click', function (e) {
      if (!searchInputHasMinChars(searchInput)) return;
      e.preventDefault();
      const relatedPopup = getPopupForInput(searchInput);
      const relatedPopupInput = relatedPopup ? relatedPopup.querySelector('.premium-hero-grid__search-input-popup') : searchPopupInput;
      showSearchPopup(searchForm, relatedPopup, searchInput, relatedPopupInput, moveRightElement);
    });

    // Tutup popup saat klik di area transparan
    if (searchPopupTransparent) {
      searchPopupTransparent.addEventListener('click', function () {
        closeSearchPopup(searchPopup, moveRightElement);
      });
    }

  });

  // Delegation: setiap tombol .premium-hero-grid__search-popup-close-button (Cancel di mobile + X) tutup popup-nya
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.premium-hero-grid__search-popup-close-button');
    if (!btn) return;
    const popup = btn.closest('.premium-hero-grid__search-popup');
    if (!popup) return;
    e.preventDefault();
    e.stopPropagation();
    const idx = Array.from(searchPopups).indexOf(popup);
    const moveRightEl = moveRightElements[idx] || null;
    closeSearchPopup(popup, moveRightEl);
  });
  document.addEventListener('mousedown', function (e) {
    const btn = e.target.closest('.premium-hero-grid__search-popup-close-button');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
  }, true);

  searchForms.forEach(function (searchForm, index) {
    const searchPopup = searchPopups[index];
    const searchPopupForm = searchPopupForms[index];
    const moveRightElement = moveRightElements[index];

    // Handle submit form di dalam popup (jika ada)
    if (searchPopupForm) {
      searchPopupForm.addEventListener('submit', function (e) {
        const popup = searchPopupForm.closest('.premium-hero-grid__search-popup');
        if (isPopupSearchSubmitBlocked(popup)) {
          e.preventDefault();
        }
      });
    }
  });

  // Fungsi untuk menampilkan search popup
  function showSearchPopup(form, popup, input, popupInput, moveRightEl) {
    if (!popup) return;

    setPopupSearchUiReady(popup, false);

    // Ambil nilai pencarian dari input asli
    const searchValue = input ? input.value : '';

    // Set nilai ke input popup; dispatch input agar handler AJAX (form.search) ikut jalan —
    // assign .value tidak memicu event input secara native.
    if (popupInput) {
      if (input) {
        syncSearchInputPair(input, popupInput, true);
      } else {
        popupInput.value = searchValue;
        popupInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    // Trigger animasi slide-out untuk elemen move-right (jika ada)
    if (moveRightEl) {
      moveRightEl.classList.add('slide-out');
    }

    // Tampilkan popup dan trigger animasi slide-in
    popup.style.display = 'flex';
    document.documentElement.classList.add('search-popup-open');
    document.body.classList.add('search-popup-open');

    // Trigger animasi popup setelah delay kecil untuk memastikan display sudah di-set
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        popup.classList.add('show');
      });
    });

    // Fokus ke input popup setelah animasi
    setTimeout(function () {
      if (popupInput) {
        popupInput.focus();
      }
    }, 400);
  }

  // Fungsi untuk menutup popup (search popup)
  function closeSearchPopup(popup, moveRightEl) {
    if (!popup) return;

    // Cancel timeout yang masih berjalan (jika ada)
    const timeoutId = popup.dataset.searchTimeout;
    if (timeoutId) {
      clearTimeout(parseInt(timeoutId));
      delete popup.dataset.searchTimeout;
    }
    delete popup.dataset.searchUiReady;

    // Reset search state: kosongkan input, results, dan reset display
    const popupInput = popup.querySelector('.premium-hero-grid__search-input-popup') ||
      popup.querySelector('input[name="q"]');
    const searchResultsContainer = popup.querySelector('#premium-hero-grid__search-results');
    const drawerSearchResult = popup.querySelector('.drawer__search-result');
    const searchSuggestionsWrapper = popup.querySelector('.premium-hero-grid__search-suggestions-wrapper');
    const searchResultsList = popup.querySelector('#premium-hero-grid__search-results-list');

    // Reset input popup + input utama (supaya sisa teks tidak langsung buka popup lagi)
    if (popupInput) {
      popupInput.value = '';
    }
    const mainSearchInput = getMainSearchInputForPopup(popup);
    if (mainSearchInput) {
      mainSearchInput.value = '';
    }

    // Reset results container
    if (searchResultsContainer) {
      searchResultsContainer.innerHTML = '';
      searchResultsContainer.style.display = 'none';
    }

    // Reset drawer search result
    if (drawerSearchResult) {
      drawerSearchResult.style.display = 'none';
    }

    // Reset suggestions wrapper (show kembali)
    if (searchSuggestionsWrapper) {
      searchSuggestionsWrapper.style.display = 'flex';
    }

    // Reset filter products jika ada
    if (searchResultsList) {
      const allItems = searchResultsList.querySelectorAll('.premium-hero-grid__search-result-item');
      allItems.forEach(function (item) {
        item.classList.add('premium-hero-grid__search-result-item--hidden');
      });
    }

    // Hapus class show untuk trigger animasi slide-out
    popup.classList.remove('show');

    // Hapus slide-out dari elemen move-right untuk reset posisi (jika ada)
    if (moveRightEl) {
      moveRightEl.classList.remove('slide-out');
    }

    // Sembunyikan popup dan restore scroll setelah animasi selesai
    setTimeout(function () {
      popup.style.display = 'none';
      var anySearchPopupOpen = document.querySelector('.premium-hero-grid__search-popup.show');
      if (!anySearchPopupOpen) {
        document.documentElement.classList.remove('search-popup-open');
        document.body.classList.remove('search-popup-open');
      }
    }, 600);
  }

  // Tutup popup dengan tombol ESC (handle search popup)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      searchPopups.forEach(function (popup, index) {
        if (popup && popup.classList.contains('show')) {
          const moveRightEl = moveRightElements[index];
          closeSearchPopup(popup, moveRightEl);
        }
      });
    }
  });

  // Fungsi pencarian produk - handle semua popup input
  searchPopupInputs.forEach(function (searchPopupInput) {
    if (!searchPopupInput) return;

    // Cari container results yang terkait dengan popup ini
    const popup = searchPopupInput.closest('.premium-hero-grid__search-popup');
    if (!popup) return;

    const searchResultsContainer = popup.querySelector('#premium-hero-grid__search-results');
    const drawerSearchResult = popup.querySelector('.drawer__search-result');
    const searchResultsList = popup.querySelector('#premium-hero-grid__search-results-list');
    const searchSuggestionsWrapper = popup.querySelector('.premium-hero-grid__search-suggestions-wrapper');

    if (searchResultsList) {
      // Dengarkan perubahan input
      searchPopupInput.addEventListener('input', function (e) {
        const searchTerm = e.target.value.trim().toLowerCase();

        // Jika search term kosong, langsung sembunyikan semua hasil dan tampilkan suggestions
        if (searchTerm === '') {
          // Langsung hide results
          if (searchResultsContainer) {
            searchResultsContainer.style.display = 'none';
          }
          if (drawerSearchResult) {
            drawerSearchResult.style.display = 'none';
          }
          // Langsung show suggestions
          if (searchSuggestionsWrapper) {
            searchSuggestionsWrapper.style.display = 'flex';
          }
          // Filter products untuk hide semua items
          filterProducts(searchResultsList, searchResultsContainer, '');
          return;
        }

        // Jika input diisi, langsung sembunyikan suggestions wrapper
        if (searchSuggestionsWrapper) {
          searchSuggestionsWrapper.style.display = 'none';
        }

        // Tampilkan results container saat mulai mengetik
        if (searchResultsContainer) {
          searchResultsContainer.style.display = 'block';
        }
        if (drawerSearchResult) {
          drawerSearchResult.style.display = 'block';
        }

        // Langsung filter products tanpa delay
        filterProducts(searchResultsList, searchResultsContainer, searchTerm);
      });
    }
  });

  // Fungsi untuk filter produk yang sudah ada di DOM
  function filterProducts(searchResultsList, searchResultsContainer, query) {
    if (!searchResultsList || !searchResultsContainer) return;

    const allItems = searchResultsList.querySelectorAll('.premium-hero-grid__search-result-item');
    let visibleCount = 0;
    const noResultsMsg = searchResultsContainer.querySelector('.premium-hero-grid__search-no-results');

    // Jika query kosong, sembunyikan semua produk
    if (!query || query.length < 2) {
      allItems.forEach(function (item) {
        item.classList.add('premium-hero-grid__search-result-item--hidden');
      });
      // Hapus pesan no results jika ada
      if (noResultsMsg) {
        noResultsMsg.remove();
      }
      return;
    }

    // Jika query ada, filter produk
    allItems.forEach(function (item) {
      const searchTitle = item.getAttribute('data-search-title') || '';
      const searchTags = item.getAttribute('data-search-tags') || '';
      const searchSkus = item.getAttribute('data-search-skus') || '';
      const searchText = (searchTitle + ' ' + searchTags + ' ' + searchSkus).toLowerCase();

      // Jika produk sesuai dengan query
      if (searchText.includes(query)) {
        item.classList.remove('premium-hero-grid__search-result-item--hidden');
        visibleCount++;
      } else {
        item.classList.add('premium-hero-grid__search-result-item--hidden');
      }
    });

    // Tampilkan/hapus pesan jika tidak ada hasil
    if (visibleCount === 0) {
      if (!noResultsMsg) {
        const noResults = document.createElement('div');
        noResults.className = 'premium-hero-grid__search-no-results';
        noResults.textContent = 'Produk tidak ditemukan';
        searchResultsContainer.appendChild(noResults);
      }
    } else {
      if (noResultsMsg) {
        noResultsMsg.remove();
      }
    }
  }

  // Handler Popup - handle multiple popups (Get Your On dan Information)
  const popupLinks = document.querySelectorAll('[data-trigger-popup]');
  const getYourOnPopups = document.querySelectorAll('.premium-hero-grid__get-your-on-popup');
  const informationPopups = document.querySelectorAll('.premium-hero-grid__information-popup');
  const allPopups = document.querySelectorAll('.premium-hero-grid__get-your-on-popup, .premium-hero-grid__information-popup');

  // Handle setiap link yang memiliki attribute data-trigger-popup
  popupLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const popupType = link.getAttribute('data-trigger-popup');
      if (!popupType || popupType === 'none') return;

      // Cek apakah link berada di header
      const isFromHeader = link.closest('header') !== null;

      // Cari popup terdekat dari link yang diklik
      // Prioritas: cari di section/header yang sama dengan link
      let popup = null;
      const parentSection = link.closest('section, header');

      if (popupType === 'get-your-on') {
        if (parentSection) {
          popup = parentSection.querySelector('.premium-hero-grid__get-your-on-popup');
        }
        if (!popup && getYourOnPopups.length > 0) {
          popup = getYourOnPopups[0];
        }
      } else if (popupType === 'information') {
        if (parentSection) {
          popup = parentSection.querySelector('.premium-hero-grid__information-popup');
        }
        if (!popup && informationPopups.length > 0) {
          popup = informationPopups[0];
        }
      }

      if (popup) {
        // Tambahkan class penanda jika dibuka dari header
        if (isFromHeader) {
          popup.classList.add('premium-hero-grid__information-popup--from-header');
        } else {
          popup.classList.remove('premium-hero-grid__information-popup--from-header');
        }
        showPopup(popup);
      }
    });
  });

  // Handle setiap popup untuk close button dan transparent area
  getYourOnPopups.forEach(function (popup) {
    const popupTransparent = popup.querySelector('.premium-hero-grid__get-your-on-popup-transparent');
    const popupCloseButton = popup.querySelector('.premium-hero-grid__get-your-on-back-button, .premium-hero-grid__get-your-on-close-button');

    if (popupTransparent) {
      popupTransparent.addEventListener('click', function () {
        closePopup(popup);
      });
    }

    if (popupCloseButton) {
      popupCloseButton.addEventListener('click', function (e) {
        e.stopPropagation();
        closePopup(popup);
      });
    }
  });

  informationPopups.forEach(function (popup) {
    const popupInner = popup.querySelector('.premium-hero-grid__information-popup-inner');
    const popupTransparent = popup.querySelector('.premium-hero-grid__information-popup-transparent');

    // Tutup popup saat klik di area transparan (luar popup)
    if (popupTransparent) {
      popupTransparent.addEventListener('click', function () {
        closePopup(popup);
      });
    }

    // Tutup popup saat klik di luar inner (di area popup tapi bukan di inner)
    popup.addEventListener('click', function (e) {
      // Jika klik tidak di dalam inner, tutup popup
      if (popupInner && !popupInner.contains(e.target)) {
        closePopup(popup);
      }
    });

    // Prevent close saat klik di dalam inner
    if (popupInner) {
      popupInner.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }
  });

  // Fungsi generic untuk menampilkan popup
  function showPopup(popup) {
    if (!popup) return;

    // Tutup semua popup lain yang mungkin terbuka
    allPopups.forEach(function (otherPopup) {
      if (otherPopup !== popup && otherPopup.classList.contains('show')) {
        closePopup(otherPopup, false);
      }
    });

    // Tampilkan popup
    popup.style.display = 'flex';

    // Trigger animasi popup setelah delay kecil
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        popup.classList.add('show');
      });
    });

    // Prevent body scroll
    document.body.style.overflow = 'hidden';
  }

  // Fungsi generic untuk menutup popup
  function closePopup(popup, restoreScroll) {
    if (!popup) return;

    // restoreScroll default true, tapi bisa di-set false jika sedang membuka popup lain
    if (restoreScroll === undefined) restoreScroll = true;

    // Hapus class show untuk trigger animasi slide-out
    popup.classList.remove('show');

    // Sembunyikan popup setelah animasi selesai
    setTimeout(function () {
      popup.style.display = 'none';

      // Hapus class penanda dari header setelah popup benar-benar tersembunyi
      popup.classList.remove('premium-hero-grid__information-popup--from-header');

      // Restore body scroll hanya jika tidak ada popup lain yang terbuka
      if (restoreScroll) {
        const hasOpenPopup = Array.from(allPopups).some(function (p) {
          return p.classList.contains('show');
        });
        if (!hasOpenPopup) {
          document.body.style.overflow = '';
        }
      }
    }, 300);
  }

  // Tutup popup dengan tombol ESC (handle semua popup yang sedang terbuka)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      allPopups.forEach(function (popup) {
        if (popup && popup.classList.contains('show')) {
          closePopup(popup);
        }
      });
    }
  });

  // Buka popup dari URL hash: #customercare → Information (Customer Care), #howtogetyouron → Get Your On
  function openPopupByHash() {
    var hash = (window.location.hash || '').toLowerCase().replace(/^#/, '');
    if (!hash) return;
    var popup = null;
    if (hash === 'customercare' && informationPopups.length > 0) {
      popup = informationPopups[0];
    } else if (hash === 'howtogetyouron' && getYourOnPopups.length > 0) {
      popup = getYourOnPopups[0];
    }
    if (popup) showPopup(popup);
  }

  function clearPopupHashOnClose(popup) {
    var hash = (window.location.hash || '').toLowerCase().replace(/^#/, '');
    if (hash === 'customercare' || hash === 'howtogetyouron') {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openPopupByHash);
  } else {
    openPopupByHash();
  }
  window.addEventListener('hashchange', openPopupByHash);

  // Saat tutup popup, hapus hash dari URL
  var closePopupOriginal = closePopup;
  closePopup = function (popup, restoreScroll) {
    clearPopupHashOnClose(popup);
    closePopupOriginal(popup, restoreScroll);
  };

  // Scroll lock PDP saat Product Popup Cart Modal (WhatsApp) terbuka di mobile
  (function initProductPopupCartModalScrollLock() {
    var bodyScrollY = 0;
    function lockBodyScroll() {
      bodyScrollY = window.scrollY || window.pageYOffset;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + bodyScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    }
    function unlockBodyScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, bodyScrollY);
    }
    var modals = document.querySelectorAll('modal-dialog.product-popup-cart-modal');
    modals.forEach(function (modal) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName !== 'open') return;
          if (modal.hasAttribute('open')) {
            lockBodyScroll();
          } else {
            unlockBodyScroll();
          }
        });
      });
      observer.observe(modal, { attributes: true });
    });
  })();

  // AJAX search untuk input popup (premium-hero-grid popup)
  document.querySelectorAll('.premium-hero-grid__search-popup form.search').forEach(function (form) {
    const popup = form.closest('.premium-hero-grid__search-popup');
    const input = form.querySelector('input[name="q"]');
    const resultsContainer = popup?.querySelector('#premium-hero-grid__search-results');
    const drawerSearchResult = popup?.querySelector('.drawer__search-result');
    const suggestionsWrapper = popup?.querySelector('.premium-hero-grid__search-suggestions-wrapper');

    if (input && resultsContainer && popup) {
      input.addEventListener('input', function () {
        const query = input.value.trim();

        // Cancel timeout sebelumnya jika ada (dari data attribute popup)
        const existingTimeout = popup.dataset.searchTimeout;
        if (existingTimeout) {
          clearTimeout(parseInt(existingTimeout));
          delete popup.dataset.searchTimeout;
        }

        // Jika input kosong, LANGSUNG eksekusi tanpa delay
        if (query.length === 0) {
          // Langsung hide results
          if (resultsContainer) {
            resultsContainer.innerHTML = '';
            resultsContainer.style.display = 'none';
          }
          if (drawerSearchResult) {
            drawerSearchResult.style.display = 'none';
          }
          // Langsung show suggestions
          if (suggestionsWrapper) {
            suggestionsWrapper.style.display = 'flex';
          }
          setPopupSearchUiReady(popup, true);
          // Return langsung, tidak lanjut ke AJAX request
          return;
        }

        // Jika query kurang dari 3 karakter
        if (query.length < 3) {
          if (resultsContainer) {
            resultsContainer.innerHTML = '<p class="font-1321">type at least 3 letters...</p>';
            resultsContainer.style.display = 'block';
          }
          if (drawerSearchResult) {
            drawerSearchResult.style.display = 'block';
          }
          if (suggestionsWrapper) {
            suggestionsWrapper.style.display = 'none';
          }
          setPopupSearchUiReady(popup, true);
          return;
        }

        setPopupSearchUiReady(popup, false);

        // Jika query >= 3 karakter, hide suggestions dan show results
        if (suggestionsWrapper) {
          suggestionsWrapper.style.display = 'none';
        }
        if (resultsContainer) {
          resultsContainer.style.display = 'block';
        }
        if (drawerSearchResult) {
          drawerSearchResult.style.display = 'block';
        }

        // Debounce untuk AJAX request (tetap pakai delay untuk optimasi server)
        // Simpan timeout ID di data attribute popup agar bisa di-cancel saat popup close
        const timeoutId = setTimeout(function () {
          const qForRequest = input.value.trim();
          const requestUrl =
            '/search?q=' + encodeURIComponent(qForRequest) +
            '&type=product&options[prefix]=last&view=ajax';
          $.get(requestUrl, function (html) {
            if (input.value.trim() === qForRequest && qForRequest.length >= 3) {
              resultsContainer.innerHTML = html;
            }
          }).always(function () {
            if (input.value.trim() === qForRequest && qForRequest.length >= 3) {
              setPopupSearchUiReady(popup, true);
            }
          });
          delete popup.dataset.searchTimeout;
        }, 300);
        popup.dataset.searchTimeout = timeoutId.toString();
      });
    }
  });

  // Handle klik search-chip - set input dan trigger input event (sambungkan dengan input handler)
  document.querySelectorAll('.search-chip').forEach(function (chip) {
    chip.addEventListener('click', function (e) {
      e.preventDefault();
      const searchValue = chip.getAttribute('data-search') || chip.textContent.trim();
      const popup = chip.closest('.premium-hero-grid__search-popup');
      if (!popup) return;

      // Cari input yang sesuai (bisa premium-hero-grid__search-input-popup atau input[name="q"])
      const popupInput = popup.querySelector('.premium-hero-grid__search-input-popup') ||
        popup.querySelector('input[name="q"]');

      if (popupInput) {
        // Set value ke input
        popupInput.value = searchValue;
        // Trigger input event agar menggunakan handler yang sama (dengan cancel timeout, display logic, dll)
        const inputEvent = new Event('input', { bubbles: true });
        popupInput.dispatchEvent(inputEvent);
      }
    });
  });

});

/* ==========================================================================
   Facets popup (mobile filter) - buka/tutup popup saat klik Filters
   ========================================================================== */
function initFilterLabelToggles() {
  const labels = document.querySelectorAll('.mobile-facets__filter-label.js-filter-label-toggle');
  labels.forEach(function (el) {
    el.addEventListener('click', function () {
      const isActive = el.dataset.active === 'true';
      el.dataset.active = isActive ? 'false' : 'true';
      const param = el.getAttribute('data-filter-param');
      if (param) {
        const bubbles = document.querySelector('.facets-filter-options-bubbles[data-filter-param="' + param + '"]');
        if (bubbles) {
          if (isActive) {
            bubbles.classList.remove('is-open');
          } else {
            bubbles.classList.add('is-open');
          }
        }
      }
    });
  });
}
document.addEventListener('DOMContentLoaded', initFilterLabelToggles);

(function () {
  function openFacetsPopup() {
    const p = document.getElementById('FacetsPopup');
    const t = document.getElementById('FacetsPopupTrigger');
    if (p) {
      p.classList.remove('facets-popup--closed');
      p.classList.add('facets-popup--open');
      p.setAttribute('aria-hidden', 'false');
      document.body.classList.add('facets-popup-open');
    }
    if (t) t.setAttribute('aria-expanded', 'true');
  }
  function closeFacetsPopup() {
    const p = document.getElementById('FacetsPopup');
    const t = document.getElementById('FacetsPopupTrigger');
    if (p) {
      p.classList.remove('facets-popup--open');
      p.classList.add('facets-popup--closed');
      p.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('facets-popup-open');
    }
    if (t) t.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('DOMContentLoaded', function () {
    const trigger = document.getElementById('FacetsPopupTrigger');
    const backdrop = document.getElementById('FacetsPopupBackdrop');
    if (trigger) {
      trigger.addEventListener('click', function () {
        const p = document.getElementById('FacetsPopup');
        if (p && p.classList.contains('facets-popup--closed')) openFacetsPopup();
        else closeFacetsPopup();
      });
    }
    if (backdrop) backdrop.addEventListener('click', closeFacetsPopup);
  });
})();

// Custom Dropdown untuk Sort
(function () {
  function initCustomDropdowns() {
    document.querySelectorAll('.custom-dropdown-sort').forEach(function (dropdown) {
      const trigger = dropdown.querySelector('.custom-dropdown__trigger');
      const menu = dropdown.querySelector('.custom-dropdown__menu');
      const options = dropdown.querySelectorAll('.custom-dropdown__option');
      const hiddenInput = dropdown.querySelector('input[type="hidden"]');
      const selectedText = dropdown.querySelector('.custom-dropdown__selected');
      const form = hiddenInput ? document.getElementById(hiddenInput.getAttribute('form')) : null;

      if (!trigger || !menu || !hiddenInput) return;

      // Toggle dropdown
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        const isOpen = dropdown.getAttribute('data-open') === 'true';
        dropdown.setAttribute('data-open', isOpen ? 'false' : 'true');
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });

      // Select option
      options.forEach(function (option) {
        option.addEventListener('click', function (e) {
          e.stopPropagation();
          const value = option.getAttribute('data-value');
          const label = option.textContent.trim();

          // Update selected
          options.forEach(function (opt) {
            opt.classList.remove('is-selected');
            opt.removeAttribute('aria-current');
          });
          option.classList.add('is-selected');
          option.setAttribute('aria-current', 'true');

          // Update hidden input dan display text
          hiddenInput.value = value;
          selectedText.textContent = label;

          // Close dropdown
          dropdown.setAttribute('data-open', 'false');
          trigger.setAttribute('aria-expanded', 'false');

          // Submit form
          if (form) {
            form.submit();
          }
        });
      });

      // Close dropdown ketika click di luar
      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) {
          dropdown.setAttribute('data-open', 'false');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  // Initialize saat DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomDropdowns);
  } else {
    initCustomDropdowns();
  }

  // Re-initialize setelah AJAX update (jika ada)
  document.addEventListener('facetFiltersForm:updated', initCustomDropdowns);

  // Sort + Gender Dropdown Handler
  function initSortDropdown() {
    document.querySelectorAll('.filter-group--sort-dropdown, .filter-group--gender-dropdown, .filter-group--shoes-size-dropdown, .filter-group--apparel-size-dropdown, .filter-group--accesories-size-dropdown').forEach(function (dropdown) {
      // PHG popup cart punya handler dropdown sendiri di color-swatch-checkbox.
      // Skip di sini supaya tidak bentrok pada state open/close.
      if (dropdown.hasAttribute('data-phg-size-dropdown')) return;
      const trigger = dropdown.querySelector('.filter-group-display__trigger');
      const menu = dropdown.querySelector('.filter-group-display__list');
      if (!trigger || !menu) return;

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = menu.style.display === 'block';

        // Tutup dropdown lain
        document.querySelectorAll('.filter-group--sort-dropdown .filter-group-display__list, .filter-group--gender-dropdown .filter-group-display__list, .filter-group--shoes-size-dropdown .filter-group-display__list, .filter-group--apparel-size-dropdown .filter-group-display__list, .filter-group--accesories-size-dropdown .filter-group-display__list').forEach(function (m) {
          if (m !== menu) m.style.display = 'none';
        });
        document.querySelectorAll('.filter-group--sort-dropdown .filter-group-display__trigger, .filter-group--gender-dropdown .filter-group-display__trigger, .filter-group--shoes-size-dropdown .filter-group-display__trigger, .filter-group--apparel-size-dropdown .filter-group-display__trigger, .filter-group--accesories-size-dropdown .filter-group-display__trigger').forEach(function (t) {
          if (t !== trigger) t.setAttribute('aria-expanded', 'false');
        });

        // Toggle dropdown ini
        menu.style.display = isOpen ? 'none' : 'block';
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

        if (!isOpen && menu.classList.contains('filter-shoes-size')) {
          var menuTop = menu.getBoundingClientRect().top;
          var availableHeight = window.innerHeight - menuTop - 16;
          menu.style.maxHeight = Math.max(availableHeight, 160) + 'px';
        }
      });

      // Tutup saat klik di luar
      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) {
          menu.style.display = 'none';
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSortDropdown);
  } else {
    initSortDropdown();
  }
  document.addEventListener('facetFiltersForm:updated', initSortDropdown);
})();

// delete dropdown when click outside
document.addEventListener('click', function (e) {
  document.querySelectorAll('.premium-hero-grid__link-dropdown[open]').forEach(function (dropdown) {
    if (!dropdown.contains(e.target)) {
      dropdown.removeAttribute('open');
    }
  });
});

// Mouse drag-to-scroll untuk .color-swatches dan .top--color (hanya aktif setelah mouse digeser, supaya klik swatch tetap jalan)
(function () {
  const dragScroll = {
    el: null,
    startX: 0,
    startY: 0,
    scrollLeft: 0,
    pending: false
  };
  const DRAG_THRESHOLD = 6;
  function getScrollTarget(node) {
    return node && node.closest && node.closest('.color-swatches, .top--color');
  }
  document.addEventListener('mousedown', function (e) {
    const target = getScrollTarget(e.target);
    if (!target || e.button !== 0) return;
    dragScroll.el = target;
    dragScroll.startX = e.pageX;
    dragScroll.startY = e.pageY;
    dragScroll.scrollLeft = target.scrollLeft;
    dragScroll.pending = true;
  });
  document.addEventListener('mousemove', function (e) {
    if (!dragScroll.el) return;
    if (dragScroll.pending) {
      const dx = Math.abs(e.pageX - dragScroll.startX);
      const dy = Math.abs(e.pageY - dragScroll.startY);
      if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
        dragScroll.pending = false;
        dragScroll.el.classList.add('is-dragging');
      }
    }
    if (!dragScroll.pending && dragScroll.el) {
      e.preventDefault();
      const walk = dragScroll.startX - e.pageX;
      dragScroll.el.scrollLeft = dragScroll.scrollLeft + walk;
    }
  });
  document.addEventListener('mouseup', function () {
    if (dragScroll.el) {
      dragScroll.el.classList.remove('is-dragging');
      dragScroll.el = null;
    }
    dragScroll.pending = false;
  });
  document.addEventListener('mouseleave', function () {
    if (dragScroll.el) {
      dragScroll.el.classList.remove('is-dragging');
      dragScroll.el = null;
    }
    dragScroll.pending = false;
  });
})();

/* ========== Custom: Facet single-select (1 nilai aktif per grup, klik lain = ganti) ========== */
(document.addEventListener('click', function (e) {
  const link = e.target.closest('a[data-single-select]');
  if (!link) return;
  e.preventDefault();

  const filterParam = link.getAttribute('data-filter-param');
  const valueParam = link.getAttribute('data-value-param');
  const valueVal = link.getAttribute('data-value');
  const explicitScope = (link.getAttribute('data-facet-scope') || '').toLowerCase();
  if (!filterParam || !valueParam || valueVal == null) return;
  const current = new URLSearchParams(window.location.search);

  function normalizeParamValue(v) {
    return decodeURIComponent(String(v || '')).toLowerCase();
  }

  function applyPressedState(linkEl, pressed) {
    if (!linkEl) return;
    linkEl.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    const isActiveByAria = linkEl.getAttribute('aria-pressed') === 'true';
    linkEl.classList.toggle('active', isActiveByAria);
    if (linkEl.classList.contains('mobile-facets__category-pill')) {
      linkEl.classList.toggle('mobile-facets__category-pill--active', isActiveByAria);
    }
    const li = linkEl.closest('.facets__item, .mobile-facets__item-horizontal');
    if (li) li.classList.toggle('facets__item--active', isActiveByAria);
  }

  function syncFilterDropdownTrigger(isActive) {
    const dropdown = link.closest(
      '.filter-group--gender-dropdown, .filter-group--shoes-size-dropdown, .filter-group--apparel-size-dropdown, .filter-group--accesories-size-dropdown'
    );
    if (!dropdown) return;
    const triggerLabel = dropdown.querySelector('.filter-group-display__trigger > .filter-group-display__trigger-label');
    if (!triggerLabel) return;
    let fallback = 'Gender';
    if (dropdown.classList.contains('filter-group--shoes-size-dropdown')) fallback = 'Shoes Size';
    else if (dropdown.classList.contains('filter-group--apparel-size-dropdown')) fallback = 'Apparel Size';
    else if (dropdown.classList.contains('filter-group--accesories-size-dropdown')) fallback = 'Accesories Size';
    triggerLabel.textContent = isActive ? (link.textContent || '').trim() : fallback;
  }

  function syncClickedFacetGroupUi(nextParams) {
    const groupRoot =
      link.closest('.facets__side-by-side-options') ||
      link.closest('.mobile-facets__group-options') ||
      link.closest('.mobile-facets__list-horizontal') ||
      link.closest('.facets__list--side-by-side');
    if (!groupRoot) return;

    const groupLinks = groupRoot.querySelectorAll('a[data-single-select][data-filter-param][data-value]');
    let hasActiveInGroup = false;

    groupLinks.forEach(function (groupLink) {
      const p = groupLink.getAttribute('data-filter-param');
      const vp = groupLink.getAttribute('data-value-param') || '';
      const v = normalizeParamValue(groupLink.getAttribute('data-value'));
      const activeByFilterParam = nextParams.getAll(p).some((qp) => normalizeParamValue(qp) === v);
      const activeByValueParam = vp ? nextParams.getAll(vp).some((qp) => normalizeParamValue(qp) === v) : false;
      const isActive = activeByFilterParam || activeByValueParam;
      if (isActive) hasActiveInGroup = true;
      applyPressedState(groupLink, isActive);
    });

    const showAllDesktop = groupRoot.querySelector('.facets__show-all-button');
    if (showAllDesktop) showAllDesktop.classList.toggle('active', !hasActiveInGroup);
    const showAllMobile = groupRoot.querySelector('.mobile-facets__option-link');
    if (showAllMobile) {
      const showAllText = (showAllMobile.textContent || '').trim().toLowerCase();
      if (showAllText === 'show all') {
        showAllMobile.classList.toggle('active', !hasActiveInGroup);
      }
    }
  }

  // Gunakan URL sebagai source of truth (bukan aria-pressed di DOM yang bisa stale setelah AJAX).
  const clickedValueNorm = normalizeParamValue(valueVal);
  const isActiveFromUrl =
    current.getAll(filterParam).some((v) => normalizeParamValue(v) === clickedValueNorm) ||
    current.getAll(valueParam).some((v) => normalizeParamValue(v) === clickedValueNorm);

  if (isActiveFromUrl) {
    // Hapus hanya nilai aktif yang diklik (jangan drop nilai facet lain, termasuk Categories).
    const nextRemove = new URLSearchParams();
    current.forEach(function (val, key) {
      const sameFacetKey = key === filterParam || key === valueParam;
      if (sameFacetKey && normalizeParamValue(val) === clickedValueNorm) return;
      nextRemove.append(key, val);
    });
    // Any facet interaction should reset pagination to page 1.
    nextRemove.delete('page');
    nextRemove.delete('Page');
    // When removing an active category, also clear dependent size/product/model filters.
    const isClickedCategory =
      explicitScope === 'category' ||
      clickedValueNorm === 'footwear' ||
      clickedValueNorm === 'shoes' ||
      clickedValueNorm === 'apparel' ||
      clickedValueNorm === 'accessories' ||
      clickedValueNorm === 'accesories';
    if (isClickedCategory) {
      Array.from(nextRemove.keys()).forEach((k) => {
        const lowerKey = String(k || '').toLowerCase();
        if (
          lowerKey.indexOf('size') !== -1 ||
          lowerKey.indexOf('model') !== -1 ||
          lowerKey.indexOf('product') !== -1
        ) {
          nextRemove.delete(k);
        }
      });
    }
    syncClickedFacetGroupUi(nextRemove);
    syncFilterDropdownTrigger(false);
    const searchParams = nextRemove.toString();

    if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderPage === 'function') {
      // Force fresh fetch so product grid/state is re-rendered, not served from stale facet cache.
      if (Array.isArray(FacetFiltersForm.filterData)) {
        FacetFiltersForm.filterData = [];
      }
      FacetFiltersForm.renderPage(searchParams, e);
      return;
    }
    window.location.href = window.location.pathname + (searchParams ? '?' + searchParams : '');
    return;
  }

  const next = new URLSearchParams();
  function getFacetScope(value) {
    const v = String(value || '').toLowerCase();
    if (v.indexOf('activity_') !== -1 || v.indexOf('activity-') !== -1) return 'activity';
    if (v.indexOf('model_') !== -1 || v.indexOf('model-') !== -1) return 'model';
    if (v.indexOf('gender-') !== -1 || v.indexOf('gender_') !== -1) return 'gender';
    if (v.indexOf('special-') === 0 || v.indexOf('special_') === 0) return 'collection';
    return 'category';
  }
  function getFacetScopeFromParams(filterParamName, valueParamName, fallbackValue) {
    const key = (String(filterParamName || '') + ' ' + String(valueParamName || '')).toLowerCase();
    if (key.indexOf('size') !== -1) return 'size';
    if (key.indexOf('activity') !== -1) return 'activity';
    if (key.indexOf('model') !== -1) return 'model';
    return getFacetScope(fallbackValue);
  }
  function isShoesCategoryValue(value) {
    const v = String(value || '').toLowerCase();
    return v === 'shoes' || v === 'footwear';
  }
  function isCategoryFacetValue(value) {
    const v = String(value || '').toLowerCase();
    return (
      v === 'shoes' ||
      v === 'footwear' ||
      v === 'apparel' ||
      v === 'accessories' ||
      v === 'accesories'
    );
  }
  const isTagFilter = filterParam.indexOf('tag') !== -1 || valueParam.indexOf('tag') !== -1;
  const clickedScopeRaw = explicitScope || getFacetScopeFromParams(filterParam, valueParam, valueVal);
  const clickedScope = clickedScopeRaw === 'size' ? 'size' : clickedScopeRaw;
  const clickedCategoryValue = normalizeParamValue(valueVal);
  const isCategorySwitch = clickedScope === 'category' && isCategoryFacetValue(clickedCategoryValue);
  const shouldClearSizeForCategorySwitch = isCategorySwitch && !isShoesCategoryValue(clickedCategoryValue);
  current.forEach(function (val, key) {
    const lowerKey = String(key || '').toLowerCase();
    // When switching categories (apparel/accessories/shoes/etc),
    // clear dependent facet values that should not carry to another category.
    if (isCategorySwitch && lowerKey.indexOf('model') !== -1) {
      return;
    }
    if (shouldClearSizeForCategorySwitch && (lowerKey.indexOf('size') !== -1 || lowerKey.indexOf('product') !== -1)) {
      return;
    }
    if (key !== filterParam) {
      next.append(key, val);
      return;
    }
    // For tag-based filters:
    // - Keep values from other logical groups
    // - BUT when replacing a category, clear any active model_ values as well
    if (isTagFilter) {
      const scope = getFacetScope(val);
      if (scope === clickedScope) return;
      if (isCategorySwitch && scope === 'model') return; // clear old Product-type/model_ filters
      next.append(key, val);
    }
  });

  // Extra safety: ensure dependent query params are removed after scope switch.
  if (isCategorySwitch) {
    Array.from(next.keys()).forEach((k) => {
      const lowerKey = String(k || '').toLowerCase();
      if (lowerKey.indexOf('model') !== -1) {
        next.delete(k);
      }
      if (shouldClearSizeForCategorySwitch && (lowerKey.indexOf('size') !== -1 || lowerKey.indexOf('product') !== -1)) {
        next.delete(k);
      }
    });
  }
  // Any facet interaction should reset pagination to page 1.
  next.delete('page');
  next.delete('Page');

  next.append(valueParam, valueVal);
  syncClickedFacetGroupUi(next);
  syncFilterDropdownTrigger(true);
  const qs = next.toString();
  if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderPage === 'function') {
    // Force fresh fetch so re-activating the same filter still re-renders products.
    if (Array.isArray(FacetFiltersForm.filterData)) {
      FacetFiltersForm.filterData = [];
    }
    FacetFiltersForm.renderPage(qs, e);
    return;
  }
  window.location.href = window.location.pathname + (qs ? '?' + qs : '');
}));

/* ========== Custom: Facet breadcrumb & title (dipindah dari facets.js) ========== */
(function () {
  function escapeHtml(s) {
    const div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  function toTitleCase(s) {
    return String(s || '')
      .split(' ')
      .filter(Boolean)
      .map(function (part) {
        return part.charAt(0).toUpperCase() + part.slice(1);
      })
      .join(' ');
  }

  function normalizeFilterLabel(value) {
    const decoded = decodeURIComponent(String(value || ''));
    const lower = decoded.toLowerCase();

    if (lower.indexOf('activity_') !== -1 || lower.indexOf('activity-') !== -1) {
      return {
        group: 'activity',
        label: toTitleCase(
          decoded
            .replace(/^activity_/i, '')
            .replace(/^activity-/i, '')
            .replace(/_/g, ' ')
            .replace(/-/g, ' ')
            .trim()
        ),
      };
    }

    if (lower.indexOf('model_') !== -1 || lower.indexOf('model-') !== -1) {
      return {
        group: 'model',
        label: toTitleCase(
          decoded
            .replace(/^model_apparel_/i, '')
            .replace(/^model_accessories_/i, '')
            .replace(/^model_accesories_/i, '')
            .replace(/^model_/i, '')
            .replace(/^model-/i, '')
            .replace(/_/g, ' ')
            .replace(/-/g, ' ')
            .trim()
        ),
      };
    }

    if (lower === 'footwear' || lower === 'shoes') return { group: 'category', label: 'Shoes' };
    if (lower === 'apparel') return { group: 'category', label: 'Apparel' };
    if (lower === 'accessories' || lower === 'accesories') return { group: 'category', label: 'Accessories' };
    return { group: 'other', label: toTitleCase(decoded.replace(/_/g, ' ').replace(/-/g, ' ').trim()) };
  }

  function collectFilterGroupsFromUrl() {
    const grouped = { category: [], model: [], activity: [], other: [] };
    const seen = { category: {}, model: {}, activity: {}, other: {} };
    const params = new URLSearchParams(window.location.search || '');

    params.forEach(function (value, key) {
      if (key.indexOf('filter.') !== 0) return;
      if (key.indexOf('.price.') !== -1) return;
      const parsed = normalizeFilterLabel(value);
      if (!parsed.label) return;

      if (seen[parsed.group][parsed.label]) return;
      seen[parsed.group][parsed.label] = true;
      grouped[parsed.group].push(parsed.label);
    });

    return grouped;
  }

  function updateBreadcrumbFromActiveFilters() {
    const breadcrumb = document.querySelector('.collection-hero__breadcrumb .breadcrumb-list');
    if (!breadcrumb) return;

    const collectionNameElement = breadcrumb.querySelector('li:nth-child(2) span') ||
      document.querySelector('.collection-title-base');
    const collectionName = collectionNameElement ? collectionNameElement.textContent.trim() : '';

    const grouped = collectFilterGroupsFromUrl();
    const filterValues = [];
    if (grouped.category.length) filterValues.push(grouped.category.join(' '));
    // Keep code path for non-category groups, but disable for now per request.
    // if (grouped.model.length) filterValues.push(grouped.model.join(' '));
    // if (grouped.activity.length) filterValues.push(grouped.activity.join(' '));
    // if (grouped.other.length) filterValues.push(grouped.other.join(' '));

    const collectionUrlEl = document.querySelector('.breadcrumb-item--collection-title a');
    const collectionUrl = collectionUrlEl ? collectionUrlEl.getAttribute('href') : (window.location.pathname.split('?')[0] || '/');

    let breadcrumbHTML = ''
      + '<li class="breadcrumb-item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">'
      + '<a href="/" itemprop="item"><span itemprop="name">Home</span></a>'
      + '<meta itemprop="position" content="1"></li>'
      + '<li class="breadcrumb-item breadcrumb-item--collection-title" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">'
      + '<a href="' + collectionUrl + '" itemprop="item"><span itemprop="name">' + escapeHtml(collectionName) + '</span></a>'
      + '<meta itemprop="position" content="2"></li>';

    if (filterValues.length > 0) {
      breadcrumbHTML += ''
        + '<li class="breadcrumb-item small-hide medium-hide" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">'
        + '<span itemprop="name">' + escapeHtml(filterValues.join(' ')) + '</span>'
        + '<meta itemprop="position" content="3"></li>';
    }

    breadcrumb.innerHTML = breadcrumbHTML;
  }

  function updateTitleFromActiveFilters() {
    const titleRoot = document.getElementById('collection-title');
    if (!titleRoot) return;

    const grouped = collectFilterGroupsFromUrl();
    const parts = [];
    if (grouped.category.length) parts.push(grouped.category.join(' '));
    // Keep code path for non-category groups, but disable for now per request.
    // if (grouped.model.length) parts.push(grouped.model.join(' '));
    // if (grouped.activity.length) parts.push(grouped.activity.join(' '));
    // if (grouped.other.length) parts.push(grouped.other.join(' '));
    const text = parts.join(' ');

    let filterNode = titleRoot.querySelector('.collection-title-filters');
    if (!text) {
      if (filterNode) filterNode.remove();
      return;
    }

    if (!filterNode) {
      filterNode = document.createElement('span');
      filterNode.className = 'collection-title-filters small-hide medium-hide';
      titleRoot.appendChild(document.createTextNode(' '));
      titleRoot.appendChild(filterNode);
    }

    filterNode.textContent = text;
  }

  function patchFacetFiltersForm() {
    const Ctor =
      (typeof customElements !== 'undefined' && customElements.get('facet-filters-form')) ||
      window.FacetFiltersForm;
    if (!Ctor) return false;
    Ctor.updateBreadcrumbFromActiveFilters = updateBreadcrumbFromActiveFilters;
    Ctor.updateTitleFromActiveFilters = updateTitleFromActiveFilters;
    return true;
  }

  if (!patchFacetFiltersForm()) {
    window.addEventListener('load', function tryPatch() {
      if (patchFacetFiltersForm()) return;
      setTimeout(tryPatch, 50);
    });
  }

  // Ensure title/breadcrumb sync even when section HTML is not fully re-rendered.
  function syncCollectionHeadingFromUrl() {
    updateBreadcrumbFromActiveFilters();
    updateTitleFromActiveFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCollectionHeadingFromUrl);
  } else {
    syncCollectionHeadingFromUrl();
  }
  document.addEventListener('facetFiltersForm:updated', syncCollectionHeadingFromUrl);
  window.addEventListener('popstate', syncCollectionHeadingFromUrl);
})();  